// Adapted from $LAB/src/components/Hero.tsx. LAB's `aside` is a still capture
// figure; ours is a live floating card — the recorded takeoff replayed by
// `DroneHero3D` (a realistic three.js scene, Task 4), with a one-line
// provenance caption underneath.
// version) remains in use on /digital-twin.
import { Eyebrow } from "./Eyebrow";
import { Button } from "./Button";
import { HeroBackdrop } from "./HeroBackdrop";
import { DroneHero3D } from "./DroneHero3D";
import { SITE } from "@/content/site";
import { PROVENANCE } from "@/content/trajectory";
import mainHero from "@/assets/hero/main-hero.jpg";

export function Hero() {
  return (
    <HeroBackdrop
      image={mainHero}
      aside={
        <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-lift">
          <DroneHero3D />
          <div className="truncate border-t border-border px-4 py-2.5 text-xs text-muted-foreground">
            {PROVENANCE}
          </div>
        </div>
      }
    >
      <Eyebrow>Djinious Workshop</Eyebrow>
      <h1 className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
        {SITE.tagline}
      </h1>
      <p className="mt-5 text-xl leading-relaxed text-muted-foreground">{SITE.description}</p>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <Button to="/book-demo">Book a demo</Button>
        <Button href={SITE.appUrl} target="_blank" rel="noopener" variant="ghost">
          Open the Workshop
        </Button>
      </div>
    </HeroBackdrop>
  );
}
